import React, { useContext, memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import T from '@prisjakt/ui-translate';

const CompareLink = ({ product, category, relatedProduct }) => {
  const { linkTo } = useContext(AppContext);

  if (!product || !category || !relatedProduct) {
    return null;
  }

  return (
    <T
      domain="product"
      product={product.name}
      relatedProduct={
        <Link
          to={linkTo('productCompare', {
            category,
            products: [product, relatedProduct],
          })}
        >
          {relatedProduct.name}
        </Link>
      }
    >
      product-info.compare-link
    </T>
  );
};

CompareLink.propTypes = {
  product: PropTypes.object,
  relatedProduct: PropTypes.object,
  category: PropTypes.object,
};

CompareLink.defaultProps = {
  product: undefined,
  relatedProduct: undefined,
  category: undefined,
};

export default memo(CompareLink);
